import { useState, useEffect } from "react";
import "./modal.css";
function Modal({ SelectedUserInformation, updateUser }) {
  const [localUserData, setLocalUserData] = useState({
    num: "",
    email: "",
    postalCode: "",
    fName: "",
    lName: "",
    codeMeli: "",
    address: "",
    profilepic: null,
  });
  useEffect(() => {
    setLocalUserData({ ...SelectedUserInformation });
  }, [SelectedUserInformation]);

  return (
    <>
      <div className="modal fade edit-customer-profile-modal" id={`exampleModal`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" dir="rtl">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                ویرایش کاربر
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data">
                  <div className="edit-user-item d-flex justify-content-between"></div>

                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label className="title w-75" htmlFor="fullname-edit-user">
                      نام
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={localUserData.fName}
                      onChange={(e) =>
                        setLocalUserData({
                          ...localUserData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="fName"
                      id="fullname-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label className="title w-75" htmlFor="lName-edit-user">
                      نام خانوادگی
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={localUserData.lName}
                      onChange={(e) =>
                        setLocalUserData({
                          ...localUserData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="lName"
                      id="lName-edit-user"
                    />
                  </div>
                  <div className="edit-user-item d-flex justify-content-between mb-2 ">
                    <label className="title w-75" htmlFor="codeMeli-code-edit-user">
                      کد ملی
                    </label>
                    <input
                      type="number"
                      className="form-control text-start"
                      value={localUserData.codeMeli}
                      onChange={(e) =>
                        setLocalUserData({
                          ...localUserData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="codeMeli"
                      id="codeMeli-code-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label htmlFor="address-edit-user" className="title w-75">
                      آدرس{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={localUserData.address}
                      onChange={(e) =>
                        setLocalUserData({
                          ...localUserData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="address"
                      id="address-edit-user"
                    />
                  </div>
                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label className="title w-75" htmlFor="phone-number-edit-user">
                      شماره تماس
                    </label>
                    <input
                      type="number"
                      className="form-control text-start"
                      value={localUserData.num}
                      onChange={(e) =>
                        setLocalUserData({
                          ...localUserData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="num"
                      id="phone-number-edit-user"
                    />
                  </div>
                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label className="title w-75" htmlFor="postal-code-edit-user">
                      کد پستی
                    </label>
                    <input
                      type="number"
                      className="form-control text-start"
                      value={localUserData.postalCode}
                      onChange={(e) =>
                        setLocalUserData({
                          ...localUserData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="postalCode"
                      id="postal-code-edit-user"
                    />
                  </div>
                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label className="title w-75" htmlFor="profilepic-edit-user">
                      عکس پروفایل :
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      // accept="image/*"
                      id="profilepic"
                      name="profilepic"
                      // value={localUserData.profilepic.value}
                      onChange={(e) =>
                        setLocalUserData({
                          ...localUserData,
                          [e.target.name]: e.target.files[0],
                        })
                      }
                      name="profilepic"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between mb-2">
                    <label className="title w-75" htmlFor="email-edit-user">
                      ایمیل
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={localUserData.email}
                      onChange={(e) =>
                        setLocalUserData({
                          ...localUserData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      name="email"
                      id="email-edit-user"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary close-btn" data-bs-dismiss="modal">
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  updateUser(localUserData);
                }}
                // data-bs-dismiss="modal"
                // aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Modal;
